import React from "react";
import useAuthState from "../../hooks/useAuthState";
import styles from "./AffiliatePage.module.scss";
import WorkFlowSection from "./WorkFlowSection";
import FeatureSection from "./FeatureSection";
import FAQSection from "./FAQSection";
import { Helmet } from "react-helmet";
import whiteVideoSquirrelLogo from "../../assets/whiteVideoSquirrelLogo.svg";
import { withRouter } from "react-router-dom";
function AffiliatePage({
  children,
  backgroundImage,
  backgroundColor,
  title,
  brandName,
  history,
  showHeaderOptions = true
}) {
  const { isLoggedIn } = useAuthState();
  return (
    <>
      <nav></nav>
      <main className={styles.page}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className="container">
          <div className={styles.headerRow}>
            <img src={whiteVideoSquirrelLogo} alt="" />
            {!isLoggedIn && showHeaderOptions && (
              <div className={styles.actions}>
                <button
                  className={styles.signInButton}
                  onClick={() => history.push("/login")}
                >
                  Sign in
                </button>
                <button
                  className={styles.pinkButton}
                  onClick={() => history.push("/register")}
                >
                  Get Started
                </button>
              </div>
            )}
          </div>
        </div>
        <div style={{ backgroundColor }} className={styles.bgImage}>
          {backgroundImage && <img src={backgroundImage} />}
        </div>
        {children}
        <WorkFlowSection history={history} isLoggedIn={isLoggedIn} />
        <FeatureSection />
        {/* <FAQSection /> */}
        <div className={styles.footerRow}>
          <h1>Partner With Us Today</h1>
          <p>
            Convert your influence through your content into instant earnings by
            partnering with {brandName} today! Sign up for a Video Squirrel
            account, and begin uploading your content or go live.
          </p>
          {!isLoggedIn && (
            <button
              style={{ marginRight: 0, width: "auto", padding: "0 30px" }}
              className={styles.signUpButton}
              onClick={() => history.push("/register")}
            >
              Join Video Squirrel
            </button>
          )}
        </div>
      </main>
    </>
  );
}

export default withRouter(AffiliatePage);
